import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';
import type { FlagKeys } from '@/lib/providers/featureFlagProvider';
import { getLoopsQueryOptions } from '@/lib/queries/common/useLoopsQuery';

export async function redirectToLoopItemsIfNewUi(
  queryClient: QueryClient,
  flags: FlagKeys,
  org: string,
  orgId: string,
): Promise<void> {
  if (!flags.loopNewUi) return;
  const loopsData = await queryClient.ensureQueryData(getLoopsQueryOptions(orgId));
  const firstLoop = [...loopsData.data].sort((loopA, loopB) => loopA.id - loopB.id)[0];
  if (firstLoop) {
    throw redirect({
      to: '/org/$org/loop/$loopId/visualizations/items',
      params: { org, loopId: firstLoop.id },
      replace: true,
    });
  }
}
